<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 1.5C6.44772 1.5 6 1.94772 6 2.5C6 3.05228 6.44772 3.5 7 3.5H12C14.2091 3.5 16 5.29086 16 7.5V13.5C16 14.0523 16.4477 14.5 17 14.5C17.5523 14.5 18 14.0523 18 13.5V7.5C18 4.18629 15.3137 1.5 12 1.5H7ZM5 7.5H11C11.5523 7.5 12 7.94772 12 8.5V15.5C12 16.0523 11.5523 16.5 11 16.5H5C4.44772 16.5 4 16.0523 4 15.5V8.5C4 7.94772 4.44772 7.5 5 7.5ZM2 8.5C2 6.84315 3.34315 5.5 5 5.5H11C12.6569 5.5 14 6.84315 14 8.5V15.5C14 17.1569 12.6569 18.5 11 18.5H5C3.34315 18.5 2 17.1569 2 15.5V8.5Z"
  />
</template>
